export default __webpack_public_path__ + "static/media/artwork-kala.85520142.jpg";